import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "1px solid lightgray",
  boxShadow: 24,
  p: 4,
  pt: 2,
  outline: "none",
};

export default function ReviewModal({ imgs, title, review }) {
  const [index, setIndex] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      {imgs &&
        imgs.map((img) => {
          return (
            <img
              onClick={handleOpen}
              src={img}
              width="50"
              height="50"
              alt=""
              style={{ cursor: "pointer", marginRight: "5px" }}
            />
          );
        })}
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              onClick={handleClose}
              className="round"
              sx={{
                position: "relative",
                marginLeft: "auto",
                marginRight: 0,
                cursor: "pointer",
                p: 1,
                width: "10px",
              }}
            >
              <HighlightOffIcon />
            </Box>
            {/* <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              sx={{ pb: 2 }}
            >
              Images from the customer
            </Typography> */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {imgs.map((img, idx) => {
                if (idx === index) {
                  return (
                    <img
                      onClick={handleOpen}
                      src={img}
                      alt=""
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        maxWidth: "350px",
                        maxHeight: "350px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  );
                }
              })}
            </Box>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              {imgs.map((img, idx) => {
                return (
                  <img
                    onClick={(e) => setIndex(idx)}
                    src={img}
                    width="50"
                    height="50"
                    alt=""
                    style={{ cursor: "pointer", marginRight: "5px" }}
                  />
                );
              })}
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
